import type {
  Lfa_Conversion_Data_Rejection_Criteria,
  Lfa_Service_Acceptance_Status,
} from '~/graphql/types';
import type { FeedbackType } from '../reducer';
import { equals } from 'ramda';
import hasValue from '~/util/hasValue';

type Args = {
  prevFeedbackRef: React.MutableRefObject<FeedbackType | undefined>;
  serviceFeedback: FeedbackType;
  setSelectedOption: (
    value: React.SetStateAction<Lfa_Service_Acceptance_Status>,
  ) => void;
  setSelectedCriteria: (
    value: React.SetStateAction<Array<Lfa_Conversion_Data_Rejection_Criteria>>,
  ) => void;
  setCustomReason: (value: React.SetStateAction<string>) => void;
};

const updateLocalState = ({
  prevFeedbackRef,
  serviceFeedback,
  setSelectedOption,
  setSelectedCriteria,
  setCustomReason,
}: Args) => {
  const prevFeedback = prevFeedbackRef.current;
  const prevCustomReason = prevFeedback?.rejectionCriteria?.find(
    crit => crit.id === 'custom_reason' && hasValue(crit.reason),
  );

  const currentCustomReason = serviceFeedback.rejectionCriteria?.find(
    crit => crit.id === 'custom_reason' && hasValue(crit.reason),
  );

  const hasFeedbackChanged =
    !prevFeedback ||
    prevFeedback.answer !== serviceFeedback.answer ||
    !equals(
      prevFeedback.rejectionCriteria,
      serviceFeedback.rejectionCriteria,
    ) ||
    !equals(prevCustomReason, currentCustomReason);

  if (hasFeedbackChanged) {
    setSelectedOption(serviceFeedback.answer);
    setSelectedCriteria(serviceFeedback.rejectionCriteria);
    setCustomReason(currentCustomReason?.reason || '');

    prevFeedbackRef.current = serviceFeedback;
  }
};

export default updateLocalState;
